/// <reference path="../_all.ts" />

module part {

  PartDetailDirective.$inject = ['pageMetaService', 'partService', '$filter'];
  export function PartDetailDirective(pageMetaService: navigation.IPageMetaService, partService: IPartService, $filter: misc.IAdvancedNumberFilter): ng.IDirective {


    return {
      restrict: 'E',
      scope: {
        partToProduct: '=',  //ArtikelReferenz2Object | ErsatzteillistePart2Product
        data: '=partData',
        onProductOpen: '&',
      },
      templateUrl: 'part/PartDetailDirective',
      link: function (scope: IPartDetailDirectiveScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        scope.$watch("data.Part.ID", (newValue:string, oldValue :string) => {
          if (!newValue || newValue == oldValue) return;
          
          scope.isDocumentsLoading = true;
          partService.loadDocumentsByPart(newValue)
            .then((response) => {
              //keine animation bei wechsel durch response
              scope.animationDirection = ''; 
              //Bild "Kein Bild" ausschliessen
              scope.documents = response.data.filter((el, arr, i) => {return el.Id != 11510}) ;
              scope.documents.sort((a, b) => {
                if (a.TypeNameE == "Photo") { return -1 } else if (b.TypeNameE == "Photo") { return 1 } else { return 0 }
              });
              scope.currentDocIndex = 0;
              scope.activeDocument = scope.documents[scope.currentDocIndex];
              //scope.animationDirection = 'anim-to-left';
            })
            .catch((error) => {
              console.log(error);
              scope.docError = true;
            })
            .finally(() => {
              scope.isDocumentsLoading = false;
            });

          partService.loadYourPrice()
            .then((response) => {
              scope.yourPrice = response[newValue]; 
            })
            .catch((error) => {
              console.log(error);
              scope.yourPriceError = true;
            })
            .finally(() => {
              scope.isDocumentsLoading = false;
            });
        });

        
        scope.yourPrice = [];
        
        scope.meta = pageMetaService.getPageMeta;

        scope.currentDocIndex = 0;
        scope.docError = false;
        scope.yourPriceError = false;
                
        scope.computeStaggerChangeClass = (index) => {
          if (index < 1) return '';
          if (scope.data.PriceList[index - 1].Staffelung != scope.data.PriceList[index].Staffelung) return 'new-stagger';
        };

        scope.openProduct = (ev: ng.IAngularEvent, p : ProductRelation) => {
          scope.onProductOpen({ event: ev, product: p });
        }

        scope.getDocumentDownloadLink = (document: any) => {
          return "/svc/document.axd?id=" + document.Id + "&hl=" + scope.meta('hl');
        }

        scope.moveRight = () => {
          scope.currentDocIndex += 1;
          scope.activeDocument = scope.documents[scope.currentDocIndex];
          scope.animationDirection = 'anim-to-left';
        }

        scope.moveLeft = () => {
          scope.currentDocIndex -= 1;
          scope.activeDocument = scope.documents[scope.currentDocIndex];
          scope.animationDirection = 'anim-to-right';
        }

        scope.changeDocument = (index:number) => {          
          scope.animationDirection = scope.currentDocIndex > index ? 'anim-to-right' : 'anim-to-left';
          scope.currentDocIndex = index;
          scope.activeDocument = scope.documents[scope.currentDocIndex];
        }

        scope.produceDocInfo = (doc: PartDocument) => {
          if (!doc) return;
          return doc.RevDestName + " (" + $filter('advancedNumber')(doc.RevDestSize, 1024) + 'B)';
        }

      }
    }
  }

}